import HttpStatus from "http-status-codes";
import { type NextApiHandler } from "next";
import { object } from "yup";
import { api } from "~/lib/api";
import { createMutation } from "~/lib/reactQuery";
import { GetMarketDataStatsSchema } from "~/pages/api/get-market-data-stats";
import { createMarketDataSearchFromInput } from "~/services/marketDataSearch";

const SaveRecentMarketDataSearchSchema = object({
  search: GetMarketDataStatsSchema,
});

const handler: NextApiHandler = async (req, res) => {
  const input = SaveRecentMarketDataSearchSchema.validateSync(req.body, {
    abortEarly: false,
  });

  await createMarketDataSearchFromInput(req, {
    search: input.search,
    source: "RECENT",
  });

  res.status(HttpStatus.CREATED).json({
    message: "Recent search saved",
  });
};

export default api(handler, {
  method: "POST",
  authentication: {
    canAccessMarketData: true,
  },
});

export const useSaveRecentMarketDataSearchMutation = createMutation<
  typeof handler,
  typeof SaveRecentMarketDataSearchSchema
>({
  path: "/api/market-data-search/save-recent-market-data-search",
  schema: SaveRecentMarketDataSearchSchema,
});
